/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const AssetContext = React.createContext({});
export let appNavigatorMachine: any;

export const useSMAppNavigator = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  appNavigatorMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(appNavigatorMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    appNavigatorMachine,
    appNavigatorState: state,
    appNavigatorSend: send,
  };
};
